// extracted by mini-css-extract-plugin
export var externalLink = "_bl-0";
export var internalLinkLabel = "_bl-1";